<template>
  <div class="input-model-layout">
    <!-- 留资成功组件 -->
    <div class="success-box" v-if="submitTimeValue">
      <img :src="successSubmit.topImg" alt="" />
      <p>{{ successSubmit.tips }}</p>
      <div class="success-btn" @click="goOtherActivity">
        {{ successSubmit.buttonText }}
      </div>
    </div>
    <template v-else>
      <!-- 填写号码组件 -->
      <div class="hll-input-hint-img" v-if="configData.topImg">
        <img class="default-img" :src="configData.topImg" alt="" />
      </div>
      <!-- <div class="hll-radius-box" v-if="!showSel && want != 0">
        <ul>
          <li
            class="hll-buy"
            :class="{ on: optionsData.carType === 'buy' }"
            @click="changeType('buy', '我要买车')"
          >
            <i></i>
            <span class="tit">我要买车</span>
          </li>
          <li
            v-if="isShowRent"
            class="hll-rent"
            :class="{ on: optionsData.carType === 'rent' }"
            @click="changeType('rent', '我要租车')"
          >
            <i></i>
            <span class="tit">我要租车</span>
          </li>
        </ul>
      </div> -->
      <!-- <div class="hll-radius-box2" v-if="showSel && want != 0">
        <ul>
          <li
            class="hll-buy"
            :class="{ on: optionsData.carType === 'buy' }"
            @click="changeType('buy', '我要买新车')"
          >
            <i></i>
            <span class="tit">要买车</span>
          </li>
          <li
            v-if="isShowRent"
            class="hll-rent"
            :class="{ on: optionsData.carType === 'rent' }"
            @click="changeType('rent', '我要租车')"
          >
            <i></i>
            <span class="tit">要租车</span>
          </li>
          <li
            class="hll-rent"
            :class="{ on: optionsData.carType === 'used' }"
            @click="changeType('used', '我要买二手车')"
          >
            <i></i>
            <span class="tit">要买二手车</span>
          </li>
        </ul>
      </div> -->
      <!-- {{ configData }} -->
      <!-- new -->
      <div class="hll-radius-box2">
        <ul v-if="templateId == 253">
          <li
            class="hll-rent"
            :class="{ on: optionsData.carType === 'wc' }"
            @click="changeType('wc', '无车加入')"
          >
            <i></i>
            <span class="tit">无车加入</span>
          </li>
          <li
            class="hll-rent"
            :class="{ on: optionsData.carType === 'yc' }"
            @click="changeType('yc', '有车加入')"
          >
            <i></i>
            <span class="tit">有车加入</span>
          </li>
        </ul>
        <ul v-else>
          <li
            v-if="configData.buttonText.buy"
            class="hll-buy"
            :class="{ on: optionsData.carType === 'buy' }"
            @click="changeType('buy', '我要买新车')"
          >
            <i></i>
            <span class="tit">我要买车</span>
          </li>
          <li
            v-if="configData.buttonText.rent"
            class="hll-rent"
            :class="{ on: optionsData.carType === 'rent' }"
            @click="changeType('rent', '我要租车')"
          >
            <i></i>
            <span class="tit">我要租车</span>
          </li>
          <li
            v-if="configData.buttonText.used"
            class="hll-rent"
            :class="{ on: optionsData.carType === 'used' }"
            @click="changeType('used', '我要买二手车')"
          >
            <i></i>
            <span class="tit">二手车</span>
          </li>
          <li
            v-if="configData.buttonText.replaceBuy"
            class="hll-rent"
            :class="{ on: optionsData.carType === 'replaceBuy' }"
            @click="changeType('replaceBuy', '置换买车')"
          >
            <i></i>
            <span class="tit">置换买车</span>
          </li>
          <li
            v-if="configData.buttonText.sale"
            class="hll-rent"
            :class="{ on: optionsData.carType === 'sale' }"
            @click="changeType('sale', '我要卖车')"
          >
            <i></i>
            <span class="tit">我要卖车</span>
          </li>
        </ul>
      </div>

      <!-- new -->

      <clue-form
        :optionsData="optionsData"
        :appLocation="appLocation"
        :configData="configData"
        :isAppEnv="isAppEnv"
        :want="want"
        @openCity="openCity"
      />
      <div class="hll-submit-btn" @click="save">
        <img class="default-img" :src="configData.buttonImg" alt="" />
        <div v-if="templateId == 253">
          {{ optionsData.carType  }}
          <span v-if="optionsData.carType === 'wc'">
            无车加入
          </span>
          <span v-else-if="optionsData.carType === 'yc'">
            有车加入
          </span>
        </div>
        <div v-else>
          <span v-if="optionsData.carType === 'buy'">
            {{ configData.buttonText.buy }}
          </span>
          <span v-else-if="optionsData.carType === 'rent'">
            {{ configData.buttonText.rent }}
          </span>
          <span v-else-if="optionsData.carType === 'used'">
            {{ configData.buttonText.used }}
          </span>
          <span v-else-if="optionsData.carType === 'replaceBuy'">
            {{ configData.buttonText.replaceBuy }}
          </span>
          <span v-else-if="optionsData.carType === 'sale'">
            {{ configData.buttonText.sale }}
          </span>
        </div>
        <span>
          {{ configData.buttonText.default }}
        </span>
        <!-- <span v-if="optionsData.carType === 'rent'">{{
          configData.carName || configData.btnText
        }}</span>
        <span v-else>{{ configData.btnText || configData.carName }}</span> -->
      </div>
      <!-- 这一块 1.7.1 中添加 本次不删除 隐藏 -->
      <!-- <p v-if="configData.introduce" class="hint-tit" @click="openUrl">
        {{ configData.introduce }}
      </p> -->
      <van-checkbox v-if="configData.consentAgreement" v-model="checked">
        <span class="bottom-text"
          >我同意货拉拉平台及其合作公司深圳市啦啦配送有限公司及关联子公司对我进行电话营销</span
        ></van-checkbox
      >
    </template>
  </div>
</template>

<script>
import { recordClick } from "@/utils/recordMTA";
import { getUrlParam } from "@/utils/util";
import clueForm from "@/components/clueForm";
import { Toast } from "vant";

export default {
  components: {
    clueForm
  },
  props: [
    "configData",
    "optionsData",
    "submitTimeValue",
    "successSubmit",
    "isShowRent",
    "appLocation",
    "isAppEnv",
    "want",
    "templateId"
  ],
  data() {
    return {
      showSel: getUrlParam("threeSel") || false,
      checked: false
    };
  },
  watch: {
    "configData.customerIntention": function(n) {
      if (n.length) {
        if (this.templateId == 253) {
          this.changeType('yc')
        } else { 
          this.changeType(n[0]);
        }
      } else {
        this.changeType("no");
      }
    },
  },
  methods: {
    filterIntroduce(introduce) {
      if (introduce.includes("<link>第三方</link>")) {
        let textList = [];
        let list = introduce.split("<link>第三方</link>");
        for (let i of list) {
          if (i) {
            textList.push(i);
            textList.push("<link>第三方</link>");
          }
        }
        console.log("textList", textList);
        return textList;
      }
      console.log("introduce", introduce);
      return [introduce];
    },
    openUrl() {
      if (this.configData.openUrl) {
        window.location.href = this.configData.openUrl;
      }
    },
    openCity() {
      this.$emit("openCity");
    },
    save() {
      if (this.configData.consentAgreement && !this.checked) {
        return Toast.fail("请勾选底部授权");
      }
      const btnText = this.configData.buttonText[this.optionsData.carType];
      this.$emit("save", btnText);
      // console.log("save");
    },
    goOtherActivity() {
      // typeName: 'miniprogram',
      // recordName: '浮动图标打开小程序',
      // openPopupType: 'signIn'
      // let btnBackImg = this.successSubmit.btnBackImg;
      // let datas = {
      //   typeName: "miniprogram",
      //   url: this.successSubmit.btnBackImg,
      //   recordName: this.successSubmit.btnText || "去抽奖",
      //   openPopupType: "signIn"
      // };
      // if (btnBackImg) {
      //   if (btnBackImg.includes("https://") || btnBackImg.includes("http://")) {
      //     datas.typeName = "url";
      //   }
      // }
      // console.log("successSubmit", datas);
      const { redirectType, redirectUrl, topImg } = this.successSubmit;
      this.$emit("goOtherActivity", redirectType, redirectUrl, topImg);
    },
    changeType(typeName, name) {
      this.optionsData.carType = typeName;
      recordClick(name);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/rpx.scss";
@import "./../common.scss";

/deep/ .van-checkbox__icon--checked .van-icon {
  color: #fff;
  background-color: rgb(240, 120, 37);
  border-color: rgb(240, 120, 37);
}

.input-model-layout {
  margin: 0 rpx(30) 0 rpx(30);
  padding: rpx(20) rpx(40) rpx(40) rpx(40);
  overflow: hidden;
  background: #fff;
  border-radius: rpx(20);
  color: #383838;
  .hll-input-hint-img {
    margin-top: rpx(20);
  }
  .hint-tit {
    color: #999999;
    font-size: rpx(24);
    text-align: center;
    margin: rpx(15) 0;
    .link-text {
      color: #315efb;
    }
  }
  .ph-box {
    position: relative;
    text-align: center;
    background: #f4f4f4;
    margin-bottom: rpx(24);
    height: rpx(96);
    border-radius: rpx(50);
    width: 100%;
    overflow: hidden;
    .code-right-box {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      color: #ff3821;
      font-size: rpx(26);
      padding-right: rpx(34);
      display: flex;
      align-items: center;
    }
    .hll-cell-value {
      position: relative;
      height: rpx(90);
      text-indent: rpx(30);
      font-size: rpx(28);
      border: none;
      transition: all 0.3s;
      display: flex;
      align-items: center;
      background: #fff;
      .icon-bg {
        position: absolute;
        width: rpx(24);
        height: rpx(24);
        top: 0;
        left: rpx(5);
        bottom: 0;
        margin: auto;
      }
      span {
        vertical-align: middle;
        font-size: rpx(32);
      }
      .no-tit {
        color: #bcc0cd;
      }
    }
    .input-right-close {
      position: absolute;
      width: rpx(60);
      height: rpx(60);
      top: 0;
      right: rpx(10);
      bottom: 0;
      margin: auto;
      z-index: 30;
      .input-close {
        position: absolute;
        width: rpx(24);
        height: rpx(24);
        top: 0;
        right: rpx(10);
        bottom: 0;
        margin: auto;
        width: rpx(24);
        height: rpx(24);
        background: url("~@/assets/img/input-close.png") no-repeat;
        background-size: rpx(24) rpx(24);
        z-index: 30;
      }
    }
    .ph-input {
      padding: rpx(28) 0;
      background: #f4f4f4;
      width: 100%;
      border: none;
      text-indent: rpx(30);
      font-size: rpx(34);
      line-height: rpx(40);
      transition: all 0.3s;
    }
  }
  .captcha-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: rpx(30);
    .input-captcha {
      border: none;
      background: #f4f4f4;
      border-radius: rpx(40);
      padding: rpx(20) rpx(30);
      font-size: rpx(36);
      margin-right: rpx(30);
      max-width: rpx(400);
    }
    .btn-get-captcha {
      padding: rpx(10);
      font-size: rpx(32);
      min-width: rpx(200);
      background: #fd960b;
      color: #fff;
      border: none;
      border-radius: rpx(16);
    }
    .btn-get-captcha-disabled {
      background: #d3d1cf;
    }
  }
  .hll-radius-box {
    ul {
      display: flex;
      margin: rpx(20) 0;
      li {
        display: flex;
        align-items: center;
        margin-right: rpx(30);
        height: rpx(50);
        i {
          width: rpx(30);
          height: rpx(30);
          background: url("~@/assets/img/radius.png") no-repeat;
          background-size: 100% 100%;
          margin-right: rpx(10);
        }
        span {
          color: #212121;
          margin-right: rpx(58);
          font-size: rpx(28);
          line-height: rpx(28);
        }
        &.on {
          span {
            color: #ff3200;
          }
          i {
            background: url("~@/assets/img/radius-on.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .hll-radius-box2 {
    margin-bottom: rpx(30);
    ul {
      display: flex;
      // margin: rpx(20) 0;
      justify-content: space-around;
      li {
        display: flex;
        align-items: center;
        // margin-right: rpx(30);
        height: rpx(50);
        i {
          width: rpx(30);
          height: rpx(30);
          background: url("~@/assets/img/radius.png") no-repeat;
          background-size: 100% 100%;
          margin-right: rpx(10);
        }
        span {
          color: #212121;
          // margin-right: rpx(58);
          font-size: rpx(28);
          line-height: rpx(28);
        }
        &.on {
          span {
            color: #ff3200;
          }
          i {
            background: url("~@/assets/img/radius-on.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .success-box {
    text-align: center;
    img {
      width: rpx(160);
    }
    p {
      font-size: rpx(28);
      color: #262626;
      margin: rpx(20) 0;
    }
    .success-btn {
      display: block;
      font-size: rpx(24);
      width: rpx(300);
      height: rpx(80);
      border-radius: rpx(80);
      display: flex;
      -ms-flex-pack: center;
      justify-content: center;
      -ms-flex-align: center;
      align-items: center;
      color: #fff;
      margin: rpx(20) auto;
      background-image: linear-gradient(to right, #ff382f, #ff6631);
    }
  }
}
.bottom-text {
  color: #666666;
}
</style>
